import HomeImg from '~assets/home.svg';
import AppLogo from './assets/app_logo.svg';
import AppLogoInverse from './assets/app_logo_inverse.svg';
import { ADULTS, BASE, INFANTS } from './constants/colors';
import { WorkUnits } from './constants';

export const COLSBUSIDIO_TENANT_COLORS = {
  colsubsidio: BASE,
  infantil: INFANTS,
  adultos: ADULTS,
  gestantes: ADULTS,
  oftalmologia: ADULTS,
  hemofilia: ADULTS,
  cardiovascular: ADULTS,
  karyadb: ADULTS,
  operacion: ADULTS,
  karya: BASE
};
export const colsubsidio_settings: ImplementationSettings = {
  colors: COLSBUSIDIO_TENANT_COLORS.colsubsidio,
  envs: {
    google_recaptcha: import.meta.env.VITE_RECAPTCHA_KEY,
    backend_url: import.meta.env.VITE_BACKEND_URL
  },
  logos: {
    logo_regular: AppLogo,
    logo_inverse: AppLogoInverse,
    landing: HomeImg
  },
  workUnits: WorkUnits
};
